/**
 * Simple Scroll Detection
 * Adds 'scrolled' class to element based on screen size
 */

// For Cart Count
document.addEventListener('alpine:init', () => {
  function setCartEmptyAttribute() {
    const cartCount = Alpine.store('cart_count')?.count;
    if (typeof cartCount === 'undefined') return;
    if(cartCount === 0){
        console.log('Cart is empty');
        document.documentElement.setAttribute('cart_is_empty', true);
    }else{
        console.log('Cart is not empty');
        document.documentElement.setAttribute('cart_is_empty', false);
    }
  }

  Alpine.effect(() => {
    setCartEmptyAttribute();
  });
});

// For Chat and Klaviyo Teaser
function handleScroll() {
    const chat = document.querySelector('#ShopifyChat');
    const klavioElements = document.querySelectorAll('[class*="kl-teaser"]');
    const scrollY = window.pageYOffset;
    const threshold = window.innerWidth < 768 ? window.innerWidth/2 : 100;
    if (scrollY > threshold) {
        chat.classList.add('show');
        for (let i = 0; i < klavioElements.length; i++) {
            klavioElements[i].classList.add('show');
        }
    } else {
        chat.classList.remove('show');
        for (let i = 0; i < klavioElements.length; i++) {
            klavioElements[i].classList.remove('show');
        }
    }
}

function initScrollDetection() {
  window.addEventListener('scroll', handleScroll);
  handleScroll();
}

// Initialize when DOM is ready
window.addEventListener("load", initScrollDetection);

// Temporary: translate the Klaviyo popup in place. Remove when forms are localized in Klaviyo.
(function translateKlaviyoPopup() {
  var locale = ((document.documentElement.lang || "en").split("-")[0] || "en").toLowerCase();
  if (locale === "en") return;

  var LINES = {
    it: {
      "Join the": "Unisciti al",
      movement: "movimento",
      "Unlock your": "Sblocca il tuo",
      "extra discount": "sconto extra",
      "Get early access to new features": "Accedi in anteprima alle nuove funzioni",
      "Sign Up": "Iscriviti",
      Welcome: "Benvenuto",
      "to the Club": "nel Club",
      "This field is required": "Questo campo è obbligatorio",
      "Please enter a valid email address": "Inserisci un indirizzo email valido"
    },
    de: {
      "Join the": "Werde Teil",
      movement: "der Bewegung",
      "Unlock your": "Hol dir deinen",
      "extra discount": "Extra-Rabatt",
      "Get early access to new features": "Sei früher bei neuen Features dabei",
      "Sign Up": "Mitmachen",
      Welcome: "Willkommen",
      "to the Club": "im Club",
      "This field is required": "Dieses Feld ist erforderlich",
      "Please enter a valid email address": "Gib eine gültige E-Mail-Adresse ein"
    },
    es: {
      "Join the": "Únete al",
      movement: "movimiento",
      "Unlock your": "Desbloquea tu",
      "extra discount": "descuento extra",
      "Get early access to new features": "Accede antes a las nuevas funciones",
      "Sign Up": "Únete",
      Welcome: "Bienvenido",
      "to the Club": "al Club",
      "This field is required": "Este campo es obligatorio",
      "Please enter a valid email address": "Introduce un email válido"
    },
    fr: {
      "Join the": "Rejoins le",
      movement: "mouvement",
      "Unlock your": "Débloque ta",
      "extra discount": "réduction extra",
      "Get early access to new features": "Accède en avant-première aux nouvelles fonctions",
      "Sign Up": "Inscris-toi",
      Welcome: "Bienvenue",
      "to the Club": "dans le Club",
      "This field is required": "Ce champ est obligatoire",
      "Please enter a valid email address": "Entre une adresse email valide"
    },
    nl: {
      "Join the": "Doe mee met",
      movement: "de beweging",
      "Unlock your": "Ontgrendel je",
      "extra discount": "extra korting",
      "Get early access to new features": "Krijg als eerste toegang tot nieuwe features",
      "Sign Up": "Schrijf je in",
      Welcome: "Welkom",
      "to the Club": "in de Club",
      "This field is required": "Dit veld is verplicht",
      "Please enter a valid email address": "Vul een geldig e-mailadres in"
    }
  };

  var lines = LINES[locale];
  if (!lines) return;

  function norm(s) {
    return String(s || "")
      .replace(/[\u00a0\u2000-\u200b\ufeff]/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function rootsOf(node) {
    var found = [];
    if (!node) return found;
    if (node.querySelectorAll) {
      found = found.concat(
        Array.prototype.slice.call(
          node.querySelectorAll('#klaviyo-form-XxujAx, [id^="klaviyo-form-"], .klaviyo-form')
        )
      );
    }
    var all = node.querySelectorAll ? node.querySelectorAll("*") : [];
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) found = found.concat(rootsOf(all[i].shadowRoot));
    }
    if (node.shadowRoot) found = found.concat(rootsOf(node.shadowRoot));
    return found;
  }

  function formRoots() {
    return rootsOf(document);
  }

  function replaceExactText(root, from, to) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (norm(node.nodeValue) === from) {
        node.nodeValue = to;
      }
    }
  }

  function isPurple(el) {
    var inline = (el.style && el.style.color) || "";
    var computed = "";
    try {
      computed = window.getComputedStyle(el).color || "";
    } catch (e) {}
    return /154\s*,\s*0\s*,\s*255/.test(inline + computed) || /#9a00ff/i.test(inline);
  }

  function paintExtraDiscount(root) {
    var extra = lines["extra discount"];
    var spans = root.getElementsByTagName("span");
    for (var i = 0; i < spans.length; i++) {
      if (!isPurple(spans[i])) continue;
      spans[i].style.color = "rgb(154, 0, 255)";
      if (!spans[i].querySelector("br")) {
        spans[i].insertBefore(document.createElement("br"), spans[i].firstChild);
      }
      var textNode = null;
      var walker = document.createTreeWalker(spans[i], NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        if (norm(node.nodeValue)) {
          textNode = node;
          break;
        }
      }
      if (textNode) textNode.nodeValue = extra;
      else spans[i].appendChild(document.createTextNode(extra));
    }
  }

  function translateRoot(root) {
    var inputs = root.querySelectorAll("input[placeholder], textarea[placeholder]");
    for (var i = 0; i < inputs.length; i++) {
      if (norm(inputs[i].getAttribute("placeholder")) === "Email") {
        inputs[i].setAttribute("placeholder", locale === "de" ? "E-Mail" : "Email");
      }
    }

    Object.keys(lines).forEach(function (phrase) {
      replaceExactText(root, phrase, lines[phrase]);
    });

    paintExtraDiscount(root);

    var unlock = lines["Unlock your"];
    var extra = lines["extra discount"];
    var flat = norm(unlock + " " + extra);
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (norm(node.nodeValue) !== flat) continue;
      if (node.parentElement && isPurple(node.parentElement)) continue;
      node.nodeValue = unlock + " ";
      var span = document.createElement("span");
      span.style.color = "rgb(154, 0, 255)";
      span.appendChild(document.createElement("br"));
      span.appendChild(document.createTextNode(extra));
      node.parentNode.insertBefore(span, node.nextSibling);
      break;
    }
  }

  var applying = false;
  function run() {
    if (applying) return;
    applying = true;
    try {
      var roots = formRoots();
      for (var i = 0; i < roots.length; i++) translateRoot(roots[i]);
    } finally {
      applying = false;
    }
  }

  var timer = null;
  function schedule() {
    if (applying || timer) return;
    timer = setTimeout(function () {
      timer = null;
      run();
    }, 50);
  }

  run();
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
})();